import React, { StrictMode } from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import App from "./App";
import './App.scss'
import "./index.css"



import ScrollToTop from "./ScrollToTop";
import UserRoleContextProvider from "./context/UserRoleContext";
import { SocketProvider } from "./context/SocketContext";


const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
    <React.Fragment>
        <StrictMode>
        <BrowserRouter>
        <UserRoleContextProvider>
        <SocketProvider>
            <ScrollToTop />
            

            <App />
           
            </SocketProvider>
            </UserRoleContextProvider>
        </BrowserRouter>
            </StrictMode>
    </React.Fragment>
);

